import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { user, profile, loading, error } = useAuth();
  if (loading || (user && !profile && !error)) return <div className="min-h-screen bg-[#F8F9FB] flex items-center justify-center text-sm text-gray-500">Loading workspace...</div>;
  if (!user) {
    return <Navigate to="/consultancy/login" replace state={{ from: location.pathname }} />;
  }
  if (!profile) return <div className="min-h-screen bg-[#F8F9FB] flex items-center justify-center p-6"><div className="max-w-md bg-white border border-red-100 rounded-xl p-6 text-center"><h1 className="font-semibold text-red-700">Account access unavailable</h1><p className="text-sm text-gray-500 mt-2">{error || 'This Firebase account is not linked to an active consultancy user.'}</p></div></div>;
  return <>{children}</>;
}
